import React from 'react';
export function WhatIDo() {
  return <section className="py-20 md:py-24 px-6 md:px-12 bg-mist" data-id="element-208">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center" data-id="element-209">
        <div data-id="element-210">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-211">
            I help recent grads build a real path forward
            <span className="text-accent" data-id="element-212">.</span>
          </h2>
          <div className="space-y-6 text-lg text-ink/80 leading-relaxed" data-id="element-213">
            <p data-id="element-214">
              I work 1:1 with recent grads to help them get clear on their
              strengths, explore career directions, build confidence, and take
              practical steps toward work that fits.
            </p>
            <p className="font-medium text-teal" data-id="element-215">
              This is part coaching, part mentoring, part real-world career
              navigation.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-216">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5" data-id="element-217">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-218">
              1
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-219">Clarity</h3>
            <p className="text-sm text-ink/70" data-id="element-220">
              Get clear on strengths and explore directions.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5 translate-y-8" data-id="element-221">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-222">
              2
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-223">Confidence</h3>
            <p className="text-sm text-ink/70" data-id="element-224">
              Build confidence to talk about yourself.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5" data-id="element-225">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-226">
              3
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-227">Strategy</h3>
            <p className="text-sm text-ink/70" data-id="element-228">
              Take practical steps toward work that fits.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5 translate-y-8" data-id="element-229">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-230">
              4
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-231">Support</h3>
            <p className="text-sm text-ink/70" data-id="element-232">
              Real-world career navigation and mentoring.
            </p>
          </div>
        </div>
      </div>
    </section>;
}